import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './About.css';
const About = () => {
    return (
        <Container id="about" className="about-text my-5 py-5">
            <Row>
                <Col md={5}>
                    <img className="about-image w-75" src="https://i.ibb.co/Qnp2sYH/IMG-20220112-201417-removebg-preview-1.png" alt="" />
                </Col>
                <Col md={7} className="pt-5">
                    <h3 style={{ fontWeight: "bold", color: "#CCD6F6" }}>About Me <hr /></h3>
                    <p className="my-5" style={{ color: "#8892B0" }}>Hello! My name is Aulad and I enjoy creating things that live on the internet. Innovative Front End Developer with knowledge of building and maintaining responsive websites. Proficient in HTML5, CSS3, Bootstrap, JavaScript(ES6), React.js, plus modern libraries, and frameworks. <br />
                        <br />
                        I've completed 20+ projects based on react.js with a good UI sense. Besides, I don't forget to learn about API making, the authentication system, MongoDB database.That's why node.js & express.js come gradually. <br />
                        <br />
                        Love to listen to music, play guitar, traveling & do social work.
                        Everyday life is like programming, I guess. If you love something you can put beauty into it.
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default About;